<div [formGroup]="zone4Form">
  <div class='container'>
    <div class="card">
      <div class="card-body">
        <h2 class="card-title btn-ouline-success-title">Zone n°4</h2>
        <div class="row">
          <div class='col-12'>
            <label class="form-label" >Type de pose <span class="required">*</span></label>
            <div class="btn-group d-block" role="group">
              <ng-container *ngFor="let typePose of typePoses">
                <input type="radio" formControlName="typePoseZone4" class="btn-check btn-type-pose-options" [value]="typePose.code" [id]="typePose.code + 4"
                       (change)='onRadioClickZone4(typePose.code, "typePoseZone4")' tabindex="1">
                <label class="btn btn-outline-success btn-type-pose-options" [for]="typePose.code + 4"> {{ typePose.label }}</label>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone4Form.get('typePoseZone4').value === 'TOITURE'">
      <div class="card-body">
        <h2 class="card-title">Toiture</h2>
        <div class="row">
          <div class="col-5">
            <label class="form-label" for="typeToitureZone4">Type toiture <span class="required">*</span></label>
            <select class="form-select" id="typeToitureZone4" formControlName="typeToitureZone4" tabindex="10"
                    [ngClass]="zone4Form.get('typeToitureZone4').invalid && (zone4Form.get('typeToitureZone4').dirty || zone4Form.get('typeToitureZone4').touched) ? 'is-invalid' : ''">
              <option value=""></option>
              <option *ngFor="let typeToitureZone4 of typeToitures" [ngValue]="typeToitureZone4.code"
                      [selected]="zone4Form.get('typeToitureZone4').value && typeToitureZone4.code === zone4Form.get('typeToitureZone4').value">
                {{ typeToitureZone4.label }}
              </option>
            </select>
            <div class="invalid-feedback">
              <div *ngIf="zone4Form.get('typeToitureZone4').errors?.['required']">Le type de toiture est obligatoire</div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group form-check">
              <span class="spanCheckbox">PV Ready <span class="required">*</span></span>
              <input class="form-check-input" type="checkbox" formControlName="pvReadyZone4" tabindex="11"
                     [ngClass]="zone4Form.get('pvReadyZone4').invalid && (zone4Form.get('pvReadyZone4').dirty || zone4Form.get('pvReadyZone4').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="zone4Form.get('pvReadyZone4').errors?.['required']">Cocher PV Ready</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <label for="inclinaisonZone4" class="form-label">Inclinaison <span class="required">*</span></label>
              <div class="col-10">
                <input type="number" class="form-control" id="inclinaisonZone4" formControlName="inclinaisonZone4" placeholder="Ex : 100" tabindex="12"
                       [ngClass]="zone4Form.get('inclinaisonZone4').invalid && (zone4Form.get('inclinaisonZone4').dirty || zone4Form.get('inclinaisonZone4').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone4Form.get('inclinaisonZone4').errors?.['pattern']">L'inclinaison n'est pas valide</div>
                  <div *ngIf="zone4Form.get('inclinaisonZone4').errors?.['required']">L'inclinaison est obligatoire</div>
                  <div *ngIf="zone4Form.get('inclinaisonZone4').errors?.['inclinaisonMax']">
                    L'inclinaison doit être comprise entre 0 et 3°
                  </div>

                  <div *ngIf="zone4Form.get('inclinaisonZone4').errors?.['inclinaisonMin']">
                    L'inclinaison doit être supérieure à 3°
                  </div>
                </div>
              </div>
              <div class="col-1">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="zone4Form.get('typeToitureZone4').value === 'BETON' || zone4Form.get('typeToitureZone4').value === 'TAN_ETANCHE'">
          <div class="col-12">
            <label class="form-label">Orientation</label>
            <div class="btn-group d-block" role="group">
              <input type="radio" formControlName="orientationTerrasseZone4" class="btn-check btn-type-pose-options" value="SUD" id="orientationSudZone4" tabindex="13">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationSudZone4">SUD</label>
              <input type="radio" formControlName="orientationTerrasseZone4" class="btn-check btn-type-pose-options" value="EST_OUEST" id="orientationEstOuestZone4" tabindex="14">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationEstOuestZone4">EST/OUEST</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone4Form.get('typePoseZone4').value === 'OMBRIERE'">
      <div class="card-body">
        <h2 class="card-title">Ombrière</h2>
          <div class="vehicule-options">
            <img
              src="../../../../assets/images/img/pl.png"
              alt="Poids Lourd"
              class="vehicule-img"
              [class.selected]="zone4Form.get('typeVehiculeParkingZone4')?.value === 'PL'"
              (click)="selectVehicule('PL', null)"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_1.png"
              alt="VL Place 1"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_1')"
              (click)="selectVehicule('VL', 'PLACE_1')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_2.png"
              alt="VL Place 2"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_2')"
              (click)="selectVehicule('VL', 'PLACE_2')"
            />
          
            <img
              src="../../../../assets/images/img/vl_portique.png"
              alt="VL Portique"
              class="vehicule-img"
              [class.selected]="isVLSelected('PORTIQUE')"
              (click)="selectVehicule('VL', 'PORTIQUE')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_1_bois.png"
              alt="VL Place 1 Bois"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_1_BOIS')"
              (click)="selectVehicule('VL', 'PLACE_1_BOIS')"
            />
          
            <img
              src="../../../../assets/images/img/vl_place_2_bois.png"
              alt="VL Place 2 Bois"
              class="vehicule-img"
              [class.selected]="isVLSelected('PLACE_2_BOIS')"
              (click)="selectVehicule('VL', 'PLACE_2_BOIS')"
            />

            <img
              src="../../../../assets/images/img/est_ouest.png"
              alt="VL Est Ouest"
              class="vehicule-img"
              [class.selected]="isVLSelected('EST_OUEST')"
              (click)="selectVehicule('VL', 'EST_OUEST')"
            />
          </div>
        <div
          class="error-message"
          *ngIf="
            zone4Form.get('typeVehiculeParkingZone4')?.invalid &&
            zone4Form.get('typeVehiculeParkingZone4')?.touched
          "
        >
          Le type de véhicule sur le parking est obligatoire
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone4Form.get('typePoseZone4').value">
      <div class="card-body">
        <div class="row">
          <div class='col-12'>
            <label for="surfaceZone4" class="form-label">Surface <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="surfaceZone4" formControlName="surfaceZone4" placeholder="Ex : 45.32" tabindex="8"
                   [attr.disabled]="true"
                   [ngClass]="zone4Form.get('surfaceZone4').invalid && (zone4Form.get('surfaceZone4').dirty || zone4Form.get('surfaceZone4').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone4Form.get('surfaceZone4').errors?.['required']">La surface est obligatoire</div>
                  <div *ngIf="zone4Form.get('surfaceZone4').errors?.['pattern']">La surface n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">m²</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="puissanceChoisieZone4" class="form-label">Puissance choisie</label>
            <div class="row">
              <div class="col-10">
                <input
                  type="number"
                  class="form-control"
                  id="puissanceChoisieZone4"
                  formControlName="puissanceChoisieZone4"
                  (focus)="onPuissanceChoisieFocus($event)"
                  [ngClass]="(zone4Form.get('puissanceChoisieZone4').invalid && (zone4Form.get('puissanceChoisieZone4').dirty || zone4Form.get('puissanceChoisieZone4').touched)) || (zone4Form.errors?.['surfaceOrPowerRequired'] && zone4Form.get('typePoseZone4').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone4Form.get('puissanceChoisieZone4').errors?.['pattern']">La puissance choisie n'est pas valide</div>
                  <div *ngIf="zone4Form.errors?.['surfaceOrPowerRequired']">La surface ou la puissance choisie est obligatoire</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">kWc</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="azimutZone4" class="form-label">{{ azimutLabel }} <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="azimutZone4" formControlName="azimutZone4" placeholder="Ex : 100" tabindex="9"
                 [attr.disabled]="true"
                 [ngClass]="zone4Form.get('azimutZone4').invalid && (zone4Form.get('azimutZone4').dirty || zone4Form.get('azimutZone4').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone4Form.get('azimutZone4').errors?.['required']">L'azimut est obligatoire</div>
                  <div *ngIf="zone4Form.get('azimutZone4').errors?.['pattern']">L'azimut n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

